import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const VkBrandAltSize24Component = (props, ref) => (jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { d: "M12.9825 18.9276C5.46592 18.9276 1.17864 13.7746 1 5.19995H4.76513C4.8888 11.4935 7.66451 14.1593 9.86314 14.709V5.19995H13.4085V10.6278C15.5797 10.3942 17.8605 7.92075 18.63 5.19995H22.1754C21.5845 8.55285 19.111 11.0263 17.3521 12.0431C19.111 12.8676 21.9282 15.025 23 18.9276H19.0973C18.2591 16.3167 16.1706 14.2967 13.4085 14.0219V18.9276H12.9825Z", fill: "white" }) }) }));
const VkBrandAltSize24 = hoc(forwardRef(VkBrandAltSize24Component), 'VkBrandAltSize24');

export { VkBrandAltSize24 as default };
//# sourceMappingURL=VkBrandAltSize24.js.map
